module.exports = {"610821100":"神木镇","610821101":"高家堡镇","610821102":"店塔镇","610821103":"孙家岔镇","610821104":"大柳塔镇","610821105":"花石崖镇","610821106":"中鸡镇","610821107":"贺家川镇","610821108":"尔林兔镇","610821109":"万镇","610821110":"大保当镇","610821111":"马镇","610821112":"栏杆堡镇","610821113":"沙峁镇","610821114":"锦界镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610821.json
// module id = 2999
// module chunks = 0